var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicForNavBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 529 529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 96.2,
    cy: -9.7,
    fx: 96.2,
    fy: -9.7,
    r: 529.1,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0370c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#036fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#036abd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0362b0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 264.5,
    cy: -478.4,
    fx: 264.5,
    fy: -478.4,
    r: 211.8,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 264.5,
    cy: -162,
    fx: 264.5,
    fy: -162,
    r: 124.7,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 193.3,
    y1: -77.6,
    x2: 339.8,
    y2: -224.1,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 172.7,
    y1: -309.1,
    x2: 354.9,
    y2: -491.3,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527,264.5c0,145-117.5,262.5-262.5,262.5S2,409.5,2,264.5,119.5,2,264.5,2s262.5,117.5,262.5,262.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.5,527c76.1,0,144.3-32.5,192.3-84.2-32.5-74-106.3-125.8-192.3-125.8s-159.8,51.8-192.3,125.8c47.9,51.7,116.2,84.2,192.3,84.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 264.5,
    cy: 212,
    r: 124.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 264.5,
    cy: 198.9,
    r: 105
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.5,527c65.8,0,125.8-24.4,171.9-64.4-26.1-69.7-93.1-119.3-171.9-119.3s-145.8,49.7-171.9,119.3c46.1,40,106.1,64.4,171.9,64.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicForNavBar);
export default __webpack_public_path__ + "static/media/ProfilePicForNavBar.187ed370109182626e2b1ecbacabe746.svg";
export { ForwardRef as ReactComponent };